export default "__VITE_ASSET__6evFf_SF__"